<template>
  <div class="basic-page w100 pl20 pr20 pt20 pb20">
    <el-form :label-position="labelPosition" :model="formLabelAlign">
      <el-form-item>
        <el-col :span="8">
          <el-form-item label="课程名称:" label-width="80px">
            <el-input readOnly :value="formLabelAlign.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="8">
          <el-form-item label="上课班级:" label-width="80px">
            <el-input readOnly :value="formLabelAlign.classnames"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :span="8">
          <el-form-item label="班级人数:" label-width="80px">
            <el-input readOnly :value="formLabelAlign.count"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="8">
          <el-form-item label="上课教师:" label-width="80px">
            <el-input readOnly :value="formLabelAlign.teachers"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :span="8">
          <el-form-item label="上课日期:" label-width="80px">
            <el-input readOnly :value="formLabelAlign.classDate"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="8">
          <el-form-item label="上课时间:" label-width="80px">
            <el-input readOnly  :value="formLabelAlign.classTime"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :span="8">
          <el-form-item label="星期:" label-width="80px">
            <el-input  readOnly  :value="formatV(formLabelAlign.day)" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="8">
          <el-form-item label="上课节次:" label-width="80px">
            <el-input readOnly :value="formLabelAlign.knob + '节'"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col :span="18" :row="2">
          <el-form-item label="上课地点:" label-width="80px">
            <el-input readOnly :value="formLabelAlign.classrooms"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import * as api from '@/api/overseasChinese/overseasChinese'
  export default {
    props: {
      info: {
        type: Object,
        default () {
            return {};
        }
      },
    },
    data() {
      return {
        labelPosition: 'right',
        formLabelAlign: {
          classDate: "",
          classTime: "",
          classnames: "",
          classrooms: "",
          count: "",
          day: "",
          knob: "",
          name: "",
          teachers: "",
          timeType: "",
          week: ""
        }
      };
    },
    created() {
      this.getList()
    },
    methods: {
      
      getList() {
        // let {day,pkteachclassid,timeType,week,termid} = JSON.parse(this.$route.query.info)
        let {day,pkteachclassid,timeType,week,termid} = this.info
        api.selectKbDetails({
          day,
          pkteachclassid,
          timeType,
          week,
          semesterId: termid
        }).then(res => {
          if(res.data.code == 0) {
            this.formLabelAlign = res.data.data
          }
        })

      },
      formatV(value) {
        let newVal
        switch(value) {
          case '1':
            newVal = '星期一'
            break
          case '2':
            newVal = '星期二'
            break
          case '3':
            newVal = '星期三'
            break
          case '4':
            newVal = '星期四'
            break
          case '5':
            newVal = '星期五'
            break
          case '6':
            newVal = '星期六'
            break
          case '7':
            newVal = '星期天'
            break
        }
        return newVal
      }
    },
  }
</script>
<style scoped>
.basic-page {
  width: 90%;
  margin: 0 auto
}
</style>